import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ProgrammePage } from '@features/models/events/programmes/programme-page';
import { ProgrammePerformanceItemRankingChange } from '@features/models/fans/performance-item-rankings/programme-performance-item-ranking-change';
import { PerformanceItemRatingChange } from '@features/models/fans/performance-item-ratings/performance-item-rating-change';

@Injectable()
export class ProgrammePageService {

  private _getProgrammeUrl = '/programme/:id'; 
  private _postPerformanceItemRankingUrl = '/programmeperformanceitemrankinglist'; 
  private _postPerformanceItemRatingUrl = '/performanceitemrating'; 

  private _http = inject(HttpClient);

  constructor() { }

  getProgramme(programmeId: string): Observable<ProgrammePage> {
    return this._http.get<ProgrammePage>(
      this._getProgrammeUrl.replace(":id", programmeId)
    );
  }

  postProgrammePerformanceItemRankingChange(body: ProgrammePerformanceItemRankingChange) {
    console.log("Posting changes");

    this._http
        .post(this._postPerformanceItemRankingUrl, body)
        .subscribe({
            next: response => {
                console.log("Success", response);
            },
            error: error => {
                console.error("Error", error);
            }
        });
  }

  postProgrammePerformanceItemRatingChange(body: PerformanceItemRatingChange) {
    console.log("Posting changes");

    this._http
        .post(this._postPerformanceItemRatingUrl, body)
        .subscribe({
            next: response => {
                console.log("Success", response);
            },
            error: error => {
                console.error("Error", error);
            }
        });
  }

}
